import { Routes } from '@angular/router';
import { DesktopWebHomePageComponent } from '../pages/desktop-web-home-page/desktop-web-home-page.component';

export let DESKTOP_WEB_HOME_PAGE_ROUTES: Routes = [
  {
    path: '',
    component: DesktopWebHomePageComponent,
  },
];
